 
/* eslint-disable no-irregular-whitespace, @typescript-eslint/no-unused-vars, no-param-reassign, padding-line-between-statements */
import axios from 'axios';

// Base API configuration
const API_BASE_URL = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1`;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
    let userPersonalData= '';
    let userAuthData = '';
    const authData = localStorage.getItem("authData");
     
    if (authData !== null) {
      const parsedAuthData = JSON.parse(authData);
      userPersonalData = parsedAuthData.userData;
      userAuthData = parsedAuthData.userToken;
   }
  if (authData) {
    config.headers.uid =userAuthData?.uid;
    config.headers.client =userAuthData?.client;
    config.headers['access-token'] =userAuthData['access-token'];
  }
  return config;
});

// Settlement Transactions API
export const settlementAPI = {
  // Upsert (create new or update existing) settlement transaction using unified backend endpoint
  upsert: (data) => api.post('/web_portal/settlements/settlement', data),
  // List settlements (paginated)
  list: (params = {}) => api.get('/web_portal/settlements/settlement', { params }),
  
  // Get auto-calculated from date
  getAutoFromDate: (beneficiaryId) => 
    api.get(`/web_portal/settlements/settlement/auto-from-date?beneficiary_id=${beneficiaryId}`),
  
  // Get organization commission types with transaction data
  getOrganisationCommissionTypes: (beneficiaryId, params = {}) => 
    api.get(`/web_portal/settlements/settlement/org/${beneficiaryId}/commission-types`, { params }),

  // Clear a settlement transaction
  clear: (id, data) => api.patch(`/web_portal/settlements/settlement/${id}/clear`, data),

  // Reverse a settlement transaction
  reverse: (id, data) => api.patch(`/web_portal/settlements/settlement/${id}/reverse`, data)
};

// Settlement Types API
export const settlementTypesAPI = {
  getAll: () => api.get('/web_portal/settlements/settlement-types'),
  getById: (id) => api.get(`/web_portal/settlements/settlement-types/${id}`)
};

// Organizations API
export const organisationAPI = {
  // Get organizations for settlements (my_company, pto, or both)
  getSettlementOrganisations: (type = 'both') => 
    api.get(`/organisations/settlement?type=${type}`),
  
  // Update organization
  update: (id, data) => api.patch(`/organisations/${id}`, data)
};

// Financial Accounts API
export const financialAccountsAPI = {
  // Create financial account
  create: (data) => api.post('/web_portal/settlements/financial-accounts', data),
  
  // Get all financial accounts
  getAll: (params = {}) => api.get('/web_portal/settlements/financial-accounts', { params }),
  
  // Get financial account by ID
  getById: (id) => api.get(`/web_portal/settlements/financial-accounts/${id}`),
  
  // Update financial account
  update: (id, data) => api.put(`/web_portal/settlements/financial-accounts/${id}`, data),
  
  // Delete financial account
  delete: (id) => api.delete(`/web_portal/settlements/financial-accounts/${id}`),
  
  // Get by organization
  getByOrganisation: (orgId) => api.get(`/web_portal/settlements/financial-accounts/org/${orgId}`),
  
  // Get by financial account type and organization
  getByTypeAndOrg: (typeId, orgId) => api.get(`/web_portal/settlements/financial-accounts/type/${typeId}/org/${orgId}`)
};

// Financial Account Types API
export const financialAccountTypesAPI = {
  getAll: () => api.get('/web_portal/settlements/financial-account-types'),
  getById: (id) => api.get(`/web_portal/settlements/financial-account-types/${id}`)
};

// ERP Account Mappings API
export const erpAccountMappingsAPI = {
  // Create ERP account mapping
  create: (data) => api.post('/web_portal/settlements/erp-account-mappings', data),
  
  // Get all ERP account mappings
  getAll: (params = {}) => api.get('/web_portal/settlements/erp-account-mappings', { params }),
  
  // Get ERP account mapping by ID
  getById: (id) => api.get(`/web_portal/settlements/erp-account-mappings/${id}`),
  
  // Update ERP account mapping
  update: (id, data) => api.patch(`/web_portal/settlements/erp-account-mappings/${id}`, data),
  
  // Delete ERP account mapping
  delete: (id) => api.delete(`/web_portal/settlements/erp-account-mappings/${id}`),
  
  // Get by organization
  getByOrganisation: (orgId) => api.get(`/web_portal/settlements/erp-account-mappings/org/${orgId}`),
  
  // Get by financial account type
  getByType: (typeId) => api.get(`/web_portal/settlements/erp-account-mappings/type/${typeId}`)
};

// Banks API
export const banksAPI = {
  // Create bank
  create: (data) => api.post('/web_portal/settlements/banks', data),
  
  // Get all banks
  getAll: (params = {}) => api.get('/web_portal/settlements/banks', { params }),
  
  // Get bank by ID
  getById: (id) => api.get(`/web_portal/settlements/banks/${id}`),
  
  // Update bank
  update: (id, data) => api.patch(`/web_portal/settlements/banks/${id}`, data),
  
  // Delete bank
  delete: (id) => api.delete(`/web_portal/settlements/banks/${id}`)
};

// Organization Banks API
export const organisationBanksAPI = {
  // Get distinct bank names for organization
  getBankNamesByOrganisation: (orgId) => api.get(`/web_portal/settlements/organisation-banks/org/${orgId}/banks`),
  // Get bank accounts for organization filtered by bank_id
  getByOrganisationAndBank: (orgId, bankId) => api.get(`/web_portal/settlements/organisation-banks/org/${orgId}/${bankId}`),
  
  // Create organization bank
  create: (data) => api.post('/web_portal/settlements/organisation-banks', data),
  
  // Update organization bank
  update: (id, data) => api.patch(`/web_portal/settlements/organisation-banks/${id}`, data),
  
  // Delete organization bank
  delete: (id) => api.delete(`/web_portal/settlements/organisation-banks/${id}`)
};

export default api;
